import { useEffect, useRef } from 'react';
import { trackEvent } from '../components/Analytics';

/**
 * Tracks scroll depth milestones (25%, 50%, 75%, 90%, 100%)
 * Pushes events to GTM dataLayer for GA4 reporting
 */
export function useScrollTracking(pageName) {
  const milestonesRef = useRef(new Set());

  useEffect(() => {
    const milestones = [25, 50, 75, 90, 100];

    const handleScroll = () => {
      const scrollHeight = document.documentElement.scrollHeight - window.innerHeight;
      if (scrollHeight <= 0) return;

      const scrollPercent = Math.round((window.scrollY / scrollHeight) * 100);

      milestones.forEach((milestone) => {
        if (scrollPercent >= milestone && !milestonesRef.current.has(milestone)) {
          milestonesRef.current.add(milestone);
          trackEvent('scroll_depth', {
            event_category: 'engagement',
            event_label: `${pageName}_${milestone}_percent`,
            percent_scrolled: milestone,
            page_name: pageName,
          });
        }
      });
    };

    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [pageName]);
}
